import React from 'react';
import styles from './SilentPicker.module.scss';

export function PickerDivider() {
  return <hr className={styles['spectrum-picker-divider']} />;
}
